export abstract class CommonUtils
{
    public static clamp(value:number, min?:number, max?:number):number
    {
        if( min != null && value < min )
        {
            value = min;
        }

        if( max != null && value > max )
        {
            value = max;
        }

        return value;
    }

    public static shallowClone<T>(value:T):T
    {
        if( Array.isArray(value) ) return (value as Array<any>).slice() as any as T;

        if( value && typeof (value as any).clone === 'function' ) return (value as any).clone() as any;

        if( value && value instanceof Object ) return Object.assign(Object.create(Object.getPrototypeOf(value)), value);

        return value;
    }
}
